import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Content from '../Content/Content';
import useStyles from './FeatureBanner.styles';
import { Box } from '@mui/material';
import GenericImage from '../GenericImage/GenericImage';
const FeatureBanner = (props) => {
    const { headingTag = 'H3', image } = props;
    const { classes } = useStyles();
    return (_jsxs(Box, { className: classes.container, children: [_jsx(GenericImage, { classNames: [classes.image], image: image, renderSquareImage: true, renderSquaredImagesOptions: true }), _jsx(Content, Object.assign({}, props, { headingTag: headingTag, messageClasses: [classes.newMessage], headingClasses: [classes.heading], containerClasses: [classes.contentContainer], contentInnerClasses: [props.isDeliveryPassInnerContentClass ? classes.innerContent : ''], textAlignment: 'CENTER' }))] }));
};
export default FeatureBanner;
